import { render } from "./request-list-page.vue?vue&type=template&id=dfb45cb2&scoped=true"
import script from "./request-list-page.vue?vue&type=script&lang=js"
export * from "./request-list-page.vue?vue&type=script&lang=js"

import "./request-list-page.vue?vue&type=style&index=0&id=dfb45cb2&scoped=true&lang=css"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfb45cb2"]])

export default __exports__